import dayjs from "dayjs";
import { ENV } from "./utilities/EWindow"
import { store } from "./stores/dataStore/reduxStore/store";
import { breakpoints } from "./componentShare/theme/variables/breakpoints";

export const MAX_WIDTH = breakpoints.isMobile

export function getConfigFromWindowBrowser(name: ENV) {
    if (typeof document === "undefined") {
        // running in a server environment
        return null
    } else {
        // running in a browser environment
        return (window as any)?.env?.[name]
    }
}

export function buildQueryString(obj: {}) {
    const searchParams = new URLSearchParams(obj);
    return searchParams.toString()
}

export function formatDate(date: any) {
    try {
        return dayjs(date).format('DD/MM/YYYY')
    } catch (error) {
        return date
    }
}

export function getViewFullInfoByAccountId(accountId: string) {
    const { accounts, language } = store.getState().app
    const findAccount = accounts?.find((item: any) => item.acctno === accountId)
    return `${findAccount?.custodycd ?? ''}.${language === "vi" ? findAccount?.typename : findAccount?.entypename ?? ''}`
}

export function getFirstCharacterName(name: string | undefined) {
    return `${name?.toString().slice(0, 1).toUpperCase() ?? ''}`
}

export function scrollToTop(className?: string, number?: number) {
    const isMobile = window.innerWidth < MAX_WIDTH
    const content = document.querySelector(className ? `.${className}` : isMobile ? '#content-app2' : '.content-container')
    if (content) {
        content.scrollTo({ top: number ?? 0 })
    }
}

export function getScrollTop(className?: string) {
    const isMobile = window.innerWidth < MAX_WIDTH
    const containerScroll = document.querySelector(className ? `.${className}` : isMobile ? '#content-app2' : ".content-container")
    return containerScroll?.scrollTop ?? 0
}

export function validateCode(code: string) {
    const { saveVerify } = store.getState().app
    let flag = false
    if (saveVerify === true) return true

    if (code !== '') {
        flag = true
    }

    console.log('ha_check_flag', flag)
    return flag
}